import React, { Component } from 'react'

class RouteStepQuizz extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isAnswered: false
    }
  }
  checkAnswer(e, isRight) {
    const { currentStep, labelRight, labelWrong, questions } = this.props
    const currentQuestion = questions.questions.filter(question => question.step === currentStep)[0]

    if (!currentQuestion.isAnswered) {
      currentQuestion.isAnswered = true

      if (isRight) {
        currentQuestion.isRight = true
        e.currentTarget.innerHTML = labelRight
      } else {
        currentQuestion.isRight = false
        e.currentTarget.innerHTML = labelWrong
      }

      // Update cookie "quizz"
      const cookiesQuizz = window.sessionStorage.getItem('quizz') ? JSON.parse(window.sessionStorage.getItem('quizz')) : []

      if (cookiesQuizz.length > 0) {
        const indexOfCurrentQuestions = cookiesQuizz
          .findIndex(quizz => quizz.id === questions.id)
        const indexOfCurrentStepQuizz = cookiesQuizz
          .filter(quizz => quizz.id === questions.id)[0]
          .questions
          .findIndex(question => question.step === currentStep)

        cookiesQuizz[indexOfCurrentQuestions].questions[indexOfCurrentStepQuizz] = currentQuestion
      }

      window.sessionStorage.setItem('quizz', JSON.stringify(cookiesQuizz))
    }
  }
  /**
   * Display "Wrong" or "Right" message if the user has already answered the question
   * @param {Boolean} answered Answer that user has chosen
   * @param {Boolean} answer Boolean value of the answer proposal
   * @param {String} answerLabel Answer proposal
   */
  displayLabel(answered, answer, answerLabel) {
    const { labelRight, labelWrong } = this.props

    if (answered && answer) {
      return labelRight
    } else if (!answered && !answer) {
      return labelWrong
    } else {
      return answerLabel
    }
  }
  setButtonClassName(isAnswered, answered, answer) {
    if (!isAnswered) {
      return 'button--outline'
    } else {
      if (answered && answer) {
        return ''
      } else if (!answered && !answer) {
        return ''
      } else {
        return 'button--outline'
      }
    }
  }
  render() {
    const { currentStep, question: { question, answers, title_question }, questions } = this.props
    const currentQuestion = questions.questions.filter(question => question.step === currentStep)[0]

    return (
      <div className="trip__quizz">
        <div className="container">
          <div className="trip__quizz-title">{title_question}</div>
          <div className="trip__quizz-question">{question}</div>
          <div className="trip__quizz-answers">
            {answers.map(answer => (
              <button
                className={`trip__quizz-answer button button--round ${this.setButtonClassName(currentQuestion.isAnswered, currentQuestion.isRight, answer['right answer'])}`}
                type="button"
                key={answer.label_answer}
                onClick={e => this.checkAnswer(e, answer['right answer'])}
              >
                {
                  currentQuestion.isAnswered
                    ? this.displayLabel(currentQuestion.isRight, answer['right answer'], answer.label_answer)
                    : answer.label_answer
                }
              </button>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default RouteStepQuizz


// WEBPACK FOOTER //
// ./src/components/Step/StepQuizz/StepQuizz.js